import {
    Button,
    Card,
    CardActions,
    CardContent,
    Chip,
    Container,
    Grid, ImageList, ImageListItem,
    Paper, Typography,
    useMediaQuery
} from '@mui/material';
import moment from 'moment';
import { useStoreState } from 'pullstate';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import BackdropLoader from '../../components/BackdropLoader.jsx';
import CommentsTimeline from '../../components/CommentsTimeline.jsx';
import { AppStore } from '../../stores/AppStore.js';
import { api } from '../../utils/apiFunctions';
import { getCheckInGoals, getCheckIns, getGoals } from '../../utils/getData.js';
import { isCheckInDateValid } from '../../utils/isCheckInDateValid.js';
import CheckInCoachPlayerPrompts from './CheckInCoachPlayerPrompts.jsx';
import CheckInFiles from './CheckInFiles.jsx';
import CheckinGoals from './CheckinGoals.jsx';
import CheckInInpersonMeet from './CheckInInpersonMeet.jsx';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const CheckInForm = () => {
    const [checked, setChecked] = React.useState(false);
    const [player, setPlayer] = useState({})
    const [selectedDate, setSelectedDate] = useState(null)
    const { employees, checkIns, peopleBuilders, snackbar, user, pbSettings } = useStoreState(AppStore);
    const openAlert = snackbar.openAlert;
    const location = useLocation()
    const matchesSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'))
    const { playerId, checkinId, peopleBuilderId } = useParams();
    const [isCoach, setIsCoach] = useState(false)
    const [isPlayer, setIsPlayer] = useState(false)
    const [checkinData, setCheckinData] = useState({
        monthly_ref: months[moment().month()],
        meeting_date: null,
        check_in_date: moment(),
        general_comments: [],
        status: 'active',
        creation_owner_id: user.id,
        coach_id: null,
        player_id: playerId,
        check_in_type: null
    })
    const navigate = useNavigate()
    const [openLoader, setOpenLoader] = useState(false)
    const [checkinGoalData, setCheckinGoalData] = useState([{
        checki_in_id: 0,
        goal_id: 0,
        check_in_goal_status: '',
        goal_comments: ''
    }])
    const [uploadedFiles, setUploadedFiles] = useState([])
    const [params] = useState(useParams())
    const [title, setTitle] = useState('')
    const [maxDate, setMaxDate] = useState(moment())
    const [minDate, setMinDate] = useState(moment())
    const [currentPbSettings, setCurrentPbSettings] = useState([])
    const [comment, setComment] = useState('')
    const [comments, setComments] = useState([])

    const getPlayer = useCallback(async () => {
        setOpenLoader(true)
        let player = playerId ? employees.find((employee) => employee.id === playerId) : employees.find((employee) => employee.id === playerId)

        if (player) {
            let coach = employees.find((employee => employee.full_name === player.coach))
            setPlayer(player)
            setIsCoach(user.id === coach?.id)
            setIsPlayer(user.id === player?.id)
            setOpenLoader(false)
        } else {
            let checkinSelected = checkIns?.find(checkin => checkin.id === parseInt(checkinId))
            player = employees.find((employee) => employee.id === checkinSelected?.player_id)
            let coach = employees.find((employee => employee.full_name === player?.coach))
            setPlayer(player)
            setIsCoach(user.id === coach?.id)
            setIsPlayer(user.id === player?.id)
            setOpenLoader(false)
        }
    }, [employees])

    const findCoachFromUserLogged = () => {
        const userLoggedData = employees.find((employee) => employee.id === user.id)
        const coach = employees.find((employee) => employee.full_name === userLoggedData?.coach)
        setCheckinData((prevStates) => ({ ...prevStates, coach_id: coach?.id }))
    }

    const createCheckin = async () => {
        setOpenLoader(true)
        setCheckinData((prevStates) => ({ ...prevStates, files: JSON.stringify(uploadedFiles) }))
        const checkinGoalsData = checkinGoalData.filter((goal) => !goal.check_in_goal_status)

        if (checkinGoalsData.length) {
            openAlert('Please fill status in the goals', 'error')
            setOpenLoader(false)
            return
        }

        const data = {
            ...checkinData,
            files: JSON.stringify(uploadedFiles),
            checkinGoalData
        }

        const checkInDateValid = data.check_in_type !== 'monthly-review' ? isCheckInDateValid(data.check_in_date, minDate, maxDate) : true
        if (!checkInDateValid) {
            openAlert(`Check-in Date should be between ${minDate.format('YYYY-MM-DD')} and ${maxDate.format('YYYY-MM-DD')}`, 'warning')
            setOpenLoader(false)
            return
        }

        try {
            const response = await api.post('/checkins', data)

            if (response.status === 201) {
                openAlert('Check-in created successfully', 'success')
                // createLocalArrayObject('checkIns', response.data.newCheckin)
                await getCheckIns()
                await getCheckInGoals()
                await getGoals()
                // if (response.data.newCheckinGoals.length) {
                //     response.data.newCheckinGoals.map((goal) => {
                //         createLocalArrayObject('checkInGoals', goal)
                //     })
                // }
                // createLocalArrayObject('checkInGoals', response.data.newCheckinGoals)

                if (isCoach) {
                    navigate(`/team-people-builder/${playerId}`)
                } else if (isPlayer) {
                    navigate(`/personal-people-builder/${playerId}`)
                } else {
                    navigate(`/company-people-builder/${playerId}`)
                }
            } else {
                openAlert(`Oops! Something went wrong! Status: ${response.status} `, 'error')
            }

            setOpenLoader(false)
        } catch (error) {
            console.log(error)
            openAlert('Error creating check-in', 'error')
            setOpenLoader(false)
        }
    }

    const updateCheckin = async () => {
        setOpenLoader(true)
        setCheckinData((prevStates) => ({ ...prevStates, files: JSON.stringify(uploadedFiles) }))
        const data = {
            ...checkinData,
            files: JSON.stringify(uploadedFiles),
            checkinGoalData
        }

        const checkInDateValid = data.check_in_type !== 'monthly-review' ? isCheckInDateValid(data.check_in_date, minDate, maxDate) : true
        if (!checkInDateValid) {
            openAlert(`Check-in Date should be between ${minDate} and ${maxDate}`, 'warning')
            setOpenLoader(false)
            return
        }

        try {
            const response = await api.put(`/checkins/${checkinId}`, data)

            if (response.status === 200) {
                openAlert('Check-in updated successfully', 'success')
                await getCheckIns()
                await getCheckInGoals()
                // updateLocalArrayObjects('checkIns', checkinId, data)
                // updateCheckInGoalsLocalArrayObjects('checkIns', checkinId, checkinGoalData)

                // checkinGoalData.map(async (goal) => {
                //     updateLocalArrayObjects('checkInGoals', goal.id, goal)
                // })

                // updateLocalArrayObjects('checkInGoals', checkinId, response.data)

                if (isCoach) {
                    navigate(`/team-people-builder/${player.id}`)
                } else if (isPlayer) {
                    navigate(`/personal-people-builder/${player.id}`)
                } else {
                    navigate(`/company-people-builder/${player.id}`)
                }

            }

            setOpenLoader(false)
        } catch (error) {
            console.log(error)
            openAlert('Error updating check-in', 'error')
            setOpenLoader(false)
        }
    }

    const getCheckin = useCallback(() => {
        setOpenLoader(true)
        const checkin = checkIns?.find((checkin) => checkin.id === parseInt(checkinId))

        if (checkin) {
            setUploadedFiles(JSON.parse(checkin.files))
            const player = employees.find((employee) => employee.id === checkin.player_id)
            setPlayer(player)
            setComments(JSON.parse(checkin.general_comments))
            setCheckinData(checkin)
            checkin.meeting_date ? setChecked(true) : setChecked(false)
            setSelectedDate(moment(checkin?.meeting_date))
        }
        setOpenLoader(false)
    }, [checkIns])

    const removeUploadedFile = (fileToRemove) => {
        setUploadedFiles(prevFiles => prevFiles.filter(file => file.id !== fileToRemove));
    };

    useEffect(() => {
        setOpenLoader(true)
        getTitleToCheckinForm()
        if (!peopleBuilders?.length) return
        const peopleBuilderFiltered = peopleBuilders?.find((pb) => pb.id === parseInt(peopleBuilderId))
        const currentSettings = pbSettings.find((setting) => setting.id === peopleBuilderFiltered?.pb_settings_id)

        setCurrentPbSettings(currentSettings)
        const year = moment(currentSettings?.start_date).year()

        if (location.pathname.includes('mid')) {
            setCheckinData((prevStates) => ({
                ...prevStates,
                check_in_type: 'mid-year-review'
            }))
            const month = moment(currentSettings?.mid_year_checkin.split('T')[0]).month()
            setMinDate(moment(`${year}-${month + 1}-1`))
            setMaxDate(moment(`${year}-${month + 2}-1`).subtract(1, 'day'))
        } else if (location.pathname.includes('end')) {
            setCheckinData((prevStates) => ({
                ...prevStates,
                check_in_type: 'end-year-review'
            }))
            const month = moment(currentSettings?.end_year_checkin.split('T')[0]).month()
            setMinDate(moment(`${year}-${month + 1}-1`))
            setMaxDate(moment(`${year}-${month + 2}-1`).subtract(1, 'day'))
        } else {
            setCheckinData((prevStates) => ({
                ...prevStates,
                check_in_type: 'monthly-review'
            }))
            setMinDate(moment(currentSettings?.start_date))
            setMaxDate(moment(currentSettings?.end_date))
        }
        setOpenLoader(false)
    }, [pbSettings])

    const getTitleToCheckinForm = () => {
        const path = location.pathname

        if (path.includes('mid')) {
            setTitle('Mid-Year Review')
        } else if (path.includes('end')) {
            setTitle('End-Year Review')
        } else {
            setTitle('Monthly 1:1')
        }
    }

    useEffect(() => {
        if (employees?.length) {
            findCoachFromUserLogged()
            getPlayer()
        }
        if (checkIns?.length) {
            getCheckin()
        }
    }, [employees, checkinId])

    useEffect(() => {
        if (employees?.length) {
            getPlayer()
        }
    }, [])

    useEffect(() => {
        getCheckin()
    }, [checkIns])

    return (
        <Container sx={{ mt: 10 }} maxWidth='xl' >
            <BackdropLoader openBackdrop={openLoader} />
            <Card sx={{ mt: 4, maxHeight: '80vh', overflow: 'auto' }}>
                <CardContent>
                    <Paper elevation={2} sx={{ mb: 2, p: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Grid item display={matchesSmallScreen ? 'none' : 'block'}>
                            <ImageList>
                                <ImageListItem sx={{ width: '8rem', margin: 0 }}>
                                    <img src="https://iili.io/J1MU5vV.png" />
                                </ImageListItem>
                            </ImageList>
                        </Grid>
                        <Typography
                            sx={{ width: '20%', fontSize: 14, fontWeight: 'bold' }}
                            variant='span'>Player: <Chip label={player?.full_name} /> </Typography>
                        <Typography
                            sx={{ width: '20%', fontSize: 14, fontWeight: 'bold' }}
                            variant='span'>Coach: <Chip label={player?.coach} /> </Typography>
                        <Typography
                            sx={{ width: '20%', fontSize: 14, fontWeight: 'bold' }}
                            variant='span'>{new Date().toLocaleDateString('en-ca')}</Typography>
                    </Paper>
                    <Typography align='center' variant='h5'>{title}</Typography>
                    <CheckInInpersonMeet
                        checked={checked}
                        setChecked={setChecked}
                        setCheckinData={setCheckinData}
                        setSelectedDate={setSelectedDate}
                        selectedDate={selectedDate}
                        minDate={minDate.format('YYYY-MM-DD')}
                        maxDate={maxDate.format('YYYY-MM-DD')}
                        months={months}
                    />
                    <Paper>
                        <CheckinGoals
                            currentPbSettings={currentPbSettings}
                            checkinGoalData={checkinGoalData}
                            setCheckinGoalData={setCheckinGoalData}
                        />
                    </Paper>
                    <CommentsTimeline
                        comment={comment}
                        comments={comments}
                        label='General Comments'
                        setComment={setComment}
                        setComments={setComments}
                        checkinId={checkinId}
                        setCheckinData={setCheckinData}
                    />
                    {/* <TextField
                        id="outlined-multiline-static"
                        label="General Comments"
                        multiline
                        fullWidth
                        value={checkinData.general_comments || ''}
                        sx={{ mt: 2 }}
                        rows={4}
                        variant='outlined'
                        onChange={(e) => setCheckinData((prevStates) => ({ ...prevStates, general_comments: e.target.value }))}
                    />*/}
                    <CheckInCoachPlayerPrompts />
                </CardContent>
                <CheckInFiles openAlert={openAlert} uploadedFiles={uploadedFiles} removeUploadedFile={removeUploadedFile} setUploadedFiles={setUploadedFiles} />
                <CardActions sx={{ justifyContent: 'end', mb: 2 }}>
                    <Button color='error' variant='contained' onClick={() => {
                        navigate(-1)
                    }}>Cancel</Button>
                    <Button color='success' variant='contained' onClick={params.checkinId ? updateCheckin : createCheckin}>Save</Button>
                </CardActions>

            </Card>

        </Container>
    )
}

export default CheckInForm